function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M15 6.3c-.3-1.1-1.1-1.7-2.2-1.7-.1 0-1.8-.1-2.9 1.9-1.1-2-2.8-1.9-2.9-1.9-1.1 0-1.9.6-2.2 1.7-.7 2.2.8 6.1 4.9 8.8l.3.2.3-.2c3.9-2.7 5.4-6.6 4.7-8.8"
});

var SvgHeart = function SvgHeart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "heart",
    viewBox: "0 0 20 20"
  }, props), _ref);
};

export default SvgHeart;